import { useMemo } from 'react';

import useIsMountedCheck from '../useIsMountedCheck';

type ControlVariant = 'init-reset';

const useErrorControls = (errors: string[], variant: ControlVariant) => {
  const isMounted = useIsMountedCheck();
  const localErrors = useMemo(() => {
    switch (variant) {
      case 'init-reset':
        return isMounted ? errors : [];
    }
  }, [...errors, variant]);

  return localErrors;
};

export default useErrorControls;
